import React, { useState, useEffect, Dispatch, SetStateAction, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Transition } from "react-transition-group";
import { toast } from "react-toastify";
import { selectSignedIn } from "reducers/auth";
import { HeaderAction } from "App";
import { MdChat } from "react-icons/md";

type MessageIconProps = {
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderAction | null>>;
  headerActions: HeaderAction | null;
};

const MessageIcon: React.FC<MessageIconProps> = ({ ...props }) => {
  const isSignedIn = useSelector(selectSignedIn);

  const [iconOptionsActive, setIconOptionsActive] = useState(false);

  const handleIconClick = () => {
    setIconOptionsActive(!iconOptionsActive);
    props.setHeaderActions(props.headerActions === "Message" ? null : "Message");
  };

  const dropdownRef = useRef<any>(null);
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIconOptionsActive(false);

      if (props.headerActions === "Message") props.setHeaderActions(null);
    }
  };
  useEffect(() => {
    if (props.headerActions !== "Message") return;
    document.addEventListener("click", handleClickOutside);
    return () => {
      if (props.headerActions !== "Message") return;
      document.removeEventListener("click", handleClickOutside);
    };
  }, [props.headerActions]);

  if (!isSignedIn) return null;

  return (
    <div className="AccountIconContainer" ref={dropdownRef}>
      <div className="AccountIcon" onClick={handleIconClick}>
        {MdChat({ size: "25px" })}
      </div>

      <Transition
        // in={iconOptionsActive}
        in={props.headerActions === "Message"}
        timeout={50}
        mountOnEnter
        unmountOnExit
      >
        {/* <ClickOutsideDetector
          onClickOutside={() => {
            setIconOptionsActive(false);
            props.setHeaderActions(null);
          }}
        > */}
        <DropDownMenu
          setIconOptionsActive={setIconOptionsActive}
          setHeaderActions={props.setHeaderActions}
        />
        {/* </ClickOutsideDetector> */}
      </Transition>
    </div>
  );
};

export { MessageIcon };

type DropDownMenuProps = {
  setIconOptionsActive: Dispatch<SetStateAction<boolean>>;
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderAction | null>>;
};

const DropDownMenu: React.FC<DropDownMenuProps> = ({ setIconOptionsActive, setHeaderActions }) => {
  const dispatch = useDispatch();
  const handleSignOutClick = () => {
    toast.dismiss();

    setIconOptionsActive(false);
    setHeaderActions(null);
  };

  return (
    <div className="AccountIconOptionsContainer">
      <div className="AccountIconOptions"></div>
    </div>
  );
};

type ClickOutsideDetectorProps = {
  onClickOutside?(): void;
};

const ClickOutsideDetector: React.FC<ClickOutsideDetectorProps> = ({
  onClickOutside,
  children,
}) => {
  return (
    <div>
      <div className="ClickOutsideDetector" onClick={onClickOutside} />
      {children}
    </div>
  );
};
